/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

/**
 * * `open` - Open
 * `resolved` - Resolved
 * `ignored` - Ignored
 */
export type ErrorGroupStatusEnum =
  (typeof ErrorGroupStatusEnum)[keyof typeof ErrorGroupStatusEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ErrorGroupStatusEnum = {
  open: "open",
  resolved: "resolved",
  ignored: "ignored",
} as const;
